import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ZonaExtendidaPesoPrecio;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un ZonaExtendidaPesoPrecio
*/
export class ZonaExtendidaPesoPrecioEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            Precio: x => x.Precio < 0 || x.Precio == undefined ? "Obligatorio" : true,
            PesoHasta: x => x.PesoHasta < 0 || x.PesoHasta == undefined ? "Obligatorio" : true
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Number = getField(kea.Number);
        const DateTime = getField(kea.DateTime);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Editar Peso precio"
            >

                {kea.autogrid(6, [
                    <Number field="PesoHasta" label="Peso vol. hasta (kg)" />,
                    <Number field="Precio" label="Precio"  format="currency"/>,
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifasprecio/edit/components/pesosprecios/edit.tsx